export enum TreatmentType {
  Drug = 1,
  Procedure = 2,
  OtherTreatment = 3,
}
